import React, { useState, useMemo, useEffect } from 'react'
import omit from 'lodash/omit'
import {
   Typography,
   Button,
   FormControl,
   InputLabel,
   Select,
   OutlinedInput,
   FormHelperText,
   MenuItem,
   TextField,
   IconButton,
   Grid,
   Modal,
   Paper
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import TooltipInputError from '../../toolTip/ToolTipInputError'
import TRANSLATE, { VALUES, REGEXP, OPERACIONES_APLICACIONES } from 'utils/constants'
import { Autocomplete } from '@material-ui/lab'
import utils from 'utils/utils'
import Dropzone from 'react-dropzone'
import Tooltip from '@material-ui/core/Tooltip'
import CloudUploadIcon from '@material-ui/icons/CloudUpload'
import HighlightOffIcon from '@material-ui/icons/HighlightOff'
import uploadChange from '../../../images/icons/uploadChange.svg'
import uploadSave from '../../../images/icons/uploadSave.svg'
import { useHasOperation } from 'hooks/useHasOperation'

const formContainerStyle = {
   display: 'flex',
   flexDirection: 'column',
   justifyContent: 'space-between',
   alignItems: 'center',
   width: '95%',
   margin: '0 auto 10px'
}

const useStyles = makeStyles(theme => ({
   formControl: {
      width: '100%',
      minWidth: 120,
      textAlign: 'initial',
      fontSize: '14px',
      '&:not(:first-child)': {
         marginTop: '20px'
      }
   },
   helperText: {
      marginLeft: '0px',
      marginRight: '0px',
      marginTop: '0px',
      fontSize: '11px'
   },
   selectEmpty: {
      marginTop: theme.spacing(2)
   },
   button: {
      width: '100%',
      height: '40px',
      marginTop: '20px',
      color: 'white',
      background: '#3264DC'
   },
   formCleanButton: {
      color: '#3264DC',
      border: '1px solid #3264DC',
      fontWeight: 'bold',
      marginTop: 20,
      width: '100%'
   },
   disabledButton: {
      backgroundColor: '#3264DC !important',
      opacity: '0.3',
      color: '#fff !important',
      cursor: 'not-allowed'
   },
   formContainer: formContainerStyle,
   form: {
      ...formContainerStyle,
      paddingTop: '1rem'
   },
   titleOne: {
      margin: '20px 0 15px 9px',
      fontStyle: 'normal',
      fontSize: 14,
      alignSelf: 'start',
      color: '#8A8FAB',
      fontWeight: 400
   },
   // dropzone
   modal: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: 'rgba(0,0,0,.5)',
      zIndex: 10000,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
   },
   paper: {
      backgroundColor: theme.palette.background.paper,
      border: '2px solid #cecece',
      borderRadius: '4px',
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 1, 3),
      maxWidth: '550px'
   },
   confirmModalContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      padding: '1.6rem 3rem',
      gap: '1rem',
      paddingBottom: '5rem'
   },
   iconContainer: {
      alignSelf: 'center',
      marginBottom: 16
   },
   warningIcon: {
      color: '#fe6320',
      fontSize: 68
   },

   containerIconImage: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between'
   },

   uploadImage: {
      display: 'flex',
      width: '100%',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderRadius: '0px',
      border: '1px solid #8A8FAB8D',
      borderRadius: '4px',
      padding: '10px',
      marginTop: '10px',
      '&:hover': {
         cursor: 'pointer',
         backgroundColor: 'none',
         borderRadius: '4px'
      }
   },
   uploadImage2: {
      display: 'flex',
      width: '100%',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderRadius: '0px',
      border: '1px solid #f44336',
      borderRadius: '4px',
      padding: '10px',
      marginTop: '10px',
      '&:hover': {
         cursor: 'pointer',
         backgroundColor: 'none',
         borderRadius: '4px'
      }
   },
   imageText: {
      color: '#8A8FAB',
      color: '#7a7575'
   },

   imageText2: {
      color: '#f44336',
      color: '#7a7575'
   },
   errorImg: {
      color: '#f44336',
      fontSize: '11px',
      marginTop: '1px'
   },

   iconImage: {
      fontSize: 24
   },

   // modal
   modalContainer: {
      backgroundColor: '#F9FAFC',
      width: '45%',
      right: 0,
      float: 'right',
      position: 'absolute',
      borderRadius: 0
   },

   uploadIconModal: {
      backgroundColor: '#FFFFFF',
      color: '#43496A',
      width: '150px',
      height: '150px',
      marginBottom: '20px',
      '&:hover': {
         cursor: 'pointer'
      }
   },

   modalContent: {
      backgroundColor: '#F9FAFC',
      height: '100vh',
      borderRadius: 0
   },

   dropZoneAreaModal: {
      paddingTop: '45%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      textAlign: 'center'
   },

   topBoxModal: {
      position: 'absolute',
      width: '100%',
      top: '20px',
      marginRight: '20px',
      display: 'flex',
      justifyContent: 'center'
   },

   topBoxContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '95%',
      borderBottom: '1px solid #A1A4B5'
   },

   closeIcon: {
      marginRight: 10,
      marginTop: -1,
      color: '#B1B5C8',
      '& span': { color: '#3264DC', fontWeight: 600 },
      '&:hover': {
         cursor: 'pointer'
      }
   },

   spanTitleIcon: {
      display: 'block',
      color: '#43496A',
      fontWeight: '500',
      fontSize: '18px'
   },
   spanIconClick: {
      borderBottom: '1px solid #43496A',
      cursor: 'pointer'
   }
}))

const INITIAL_APPLICATION_FORM_VALIDATION = {
   name: false,
   type: false,
   resource: false,
   subdomainId: false,
   status: false,
   file: false
}

const validRequired = value => !value || value === ''

const validationsFields = {
   name: value => value.length > 60 || validRequired(value),
   resource: value => !REGEXP.URL_RESOURCES.exec(value) || validRequired(value),
   type: validRequired,
   subdomainId: validRequired,
   status: validRequired,
   file: validRequired
}

const ApplicationForm = ({
   formBehavior,
   subdomains,
   formData,
   setForm,
   actionSubmit,
   cleanCallback,
   setShowError,
   setTextError
}) => {
   const classes = useStyles()
   const [invalid, setInvalid] = useState(INITIAL_APPLICATION_FORM_VALIDATION)

   const isSearch = useMemo(() => formBehavior === VALUES.FORM_BEHAVIOR.SEARCH, [formBehavior])

   const CONSULTAR_APLICACION = useHasOperation(OPERACIONES_APLICACIONES.CONSULTAR_APLICACION)
   const REGISTRAR_APLICACION = useHasOperation(OPERACIONES_APLICACIONES.REGISTRAR_APLICACION)

   function cleanForm() {
      cleanCallback()
      setInvalid(INITIAL_APPLICATION_FORM_VALIDATION)
   }

   const subdomainsGrouped = subdomains.map(option => {
      const firstLetter = option.name[0].toUpperCase()
      return {
         firstLetter: /[0-9]/.test(firstLetter) ? '0-9' : firstLetter,
         ...option
      }
   })

   const subdomainSelected = subdomainsGrouped.filter(sub => sub.id === formData.subdomainId)

   const [subdomainObject, setSubdomainObject] = useState(subdomainSelected[0])

   const validateFields = (name, value) => {
      const isInvalidFn = name in validationsFields ? validationsFields[name] : () => {}
      const isInvalid = isInvalidFn(value)
      if (isInvalid) {
         setInvalid(inv => ({
            ...inv,
            [name]: true
         }))
      } else if (invalid[name]) {
         setInvalid(inv => ({
            ...inv,
            [name]: false
         }))
      }
   }

   const addValuesToMemory = e => {
      const { name, value } = e.target
      if (!isSearch || name === 'type') {
         validateFields(name, value)
      }

      setForm(prevFormData => ({
         ...prevFormData,
         [name]: name === 'name' ? value.toUpperCase() : value
      }))
   }

   const handleSubdomainName = (e, value) => {
      setSubdomainObject(value)
      setForm(prevData => ({
         ...prevData,
         subdomainId: value ? value.id : ''
      }))
      if (!isSearch) {
         validateFields('subdomainId', value)
      }
   }

   useEffect(() => {
      setForm(prevFormData => ({
         ...prevFormData,
         link: formData.name ? linkApplicationGenerated(formData.name) : ''
      }))
   }, [formData.name, setForm])

   const linkApplicationGenerated = name => {
      if (name) {
         return `/${name.toLowerCase().replaceAll(' ', '-')}`
      }
      return name
   }

   const registerApplication = type => {
      const newValidations = {}
      let isInvalidField = false
      const formFields =
         type === VALUES.FORM_BEHAVIOR.REGISTER
            ? omit(INITIAL_APPLICATION_FORM_VALIDATION, 'status')
            : INITIAL_APPLICATION_FORM_VALIDATION
      for (const key in formFields) {
         const isInvalid = validationsFields[key](formData[key])
         newValidations[key] = isInvalid
         if (isInvalid && !isInvalidField) {
            isInvalidField = isInvalid
         }
      }
      if (isInvalidField) {
         setInvalid(prev => {
            return { ...prev, ...newValidations }
         })
      } else {
         actionSubmit(type)
      }
   }

   const searchApplications = () => {
      actionSubmit(VALUES.FORM_BEHAVIOR.SEARCH)
   }

   const actionSubmitEvent = e => {
      e.preventDefault()
      switch (formBehavior) {
         case VALUES.FORM_BEHAVIOR.REGISTER: {
            registerApplication(VALUES.FORM_BEHAVIOR.REGISTER)
            break
         }
         case VALUES.FORM_BEHAVIOR.SEARCH: {
            searchApplications()
            break
         }
         case VALUES.FORM_BEHAVIOR.EDIT: {
            registerApplication(VALUES.FORM_BEHAVIOR.EDIT)
            break
         }
         default:
            break
      }
   }

   // dropzone
   const ICON_SIZE = 20000000 // Tamaño de las imagenes en bytes
   const ACCEPTED_FORMATS = ['.png'] // formato de las imagenes de subdominio

   const [temporalFile, setTemporalFile] = useState(null)
   const [confirmationMessage, setConfirmationMessage] = useState(false)

   const [showSuccess, setShowSuccess] = useState(false)
   const [openModal, setOpenModal] = useState(false)
   const [iconConfirm, setIconConfirm] = useState(false)
   const [iconStateChange, setIconStateChange] = useState(true)

   const handleFileAdd = (acceptedFiles, fileRejections) => {
      if (fileRejections.length === 0) {
         formData.file = acceptedFiles[0]
         formData.status = 'A'
         setTemporalFile(acceptedFiles)
         setConfirmationMessage(true)
         setIconStateChange(false)
      } else {
         setShowError(true)
         if (fileRejections[0].errors[0].code == 'file-too-large') {
            const textoError = 'El archivo de imagen sobrepasa el peso permitido'
            setTextError(textoError)
         } else {
            const textoError = 'La extensión no es válida'
            setTextError(textoError)
         }
      }
   }

   const uploadFile = () => {
      setConfirmationMessage(false)
      setIconConfirm(true)
      setShowSuccess(true)
   }

   const confirmUploadFile = () => {
      setIconConfirm(false)
      setOpenModal(false)
      setIconStateChange(true)
   }

   const cancelFileUpload = () => {
      setConfirmationMessage(false)
      setIconStateChange(true)
      setTemporalFile(null)
   }

   const closeError = () => {
      setShowError(false)
   }
   const closeSucces = () => {
      setShowSuccess(false)
   }

   const ConfirmationMessage = () => {
      return (
         <Grid
            container
            direction="column"
            style={{
               justifyContent: 'center',
               alignItems: 'center',
               marginTop: 10
            }}
         >
            <Typography style={{ width: '400px' }} variant="subtitle1">
               ¿Desea cargar el ícono {temporalFile[0].name} ?
            </Typography>

            <Grid
               item
               container
               spacing={10}
               style={{
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginTop: 10
               }}
            >
               <Button
                  variant="outlined"
                  color="primary"
                  style={{ marginRight: 30, width: '158px' }}
                  onClick={cancelFileUpload}
               >
                  Cancelar
               </Button>
               <Button
                  variant="contained"
                  color="primary"
                  style={{ width: '158px' }}
                  onClick={() => uploadFile(temporalFile[0].name)}
               >
                  Aceptar
               </Button>
            </Grid>
         </Grid>
      )
   }

   const UploadVideoMessage = () => {
      return (
         <Grid
            container
            direction="column"
            style={{
               justifyContent: 'center',
               alignItems: 'center',
               marginTop: 10
            }}
         >
            {iconConfirm == false && (
               <Typography style={{ width: '400px' }} variant="subtitle1">
                  <span className={classes.spanTitleIcon}>Arrastre y suelte aquí, su ícono.</span>
                  <Dropzone
                     onDrop={(acceptedFiles, fileRejections) => handleFileAdd(acceptedFiles, fileRejections)}
                     maxFiles={1}
                     accept={ACCEPTED_FORMATS}
                     maxSize={ICON_SIZE}
                  >
                     {({ getRootProps, getInputProps }) => (
                        <div style={{ display: 'inline' }} {...getRootProps()}>
                           <input {...getInputProps()} />
                           <span className={classes.spanIconClick}>o haga click</span>
                        </div>
                     )}
                  </Dropzone>{' '}
                  para seleccionarlo desde su equipo
               </Typography>
            )}

            {iconConfirm && (
               <>
                  <Typography variant="subtitle1">
                     ¡el ícono {temporalFile[0].name} ha sido cargado con éxito!
                  </Typography>
                  <Grid
                     item
                     container
                     spacing={10}
                     style={{
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginTop: 10
                     }}
                  >
                     <Button variant="contained" color="primary" onClick={confirmUploadFile}>
                        Aceptar
                     </Button>
                  </Grid>
               </>
            )}
         </Grid>
      )
   }

   const AddVideoModal = () => {
      return (
         <Modal open={openModal} disableEscapeKeyDown={false}>
            <div className={classes.modalContainer}>
               <Paper elevation={6} className={classes.modalContent}>
                  <div className={classes.dropZoneAreaModal}>
                     <div className={classes.topBoxModal}>
                        <div className={classes.topBoxContainer}>
                           <Typography style={{ color: '#3264DC' }}>Cargar ícono</Typography>
                           <Tooltip title="Cerrar">
                              <IconButton aria-label="Cerrar" onClick={() => setOpenModal(false)}>
                                 <HighlightOffIcon className={classes.closeIcon} />
                              </IconButton>
                           </Tooltip>
                        </div>
                     </div>
                     <Dropzone
                        onDrop={(acceptedFiles, fileRejections) => handleFileAdd(acceptedFiles, fileRejections)}
                        maxFiles={1}
                        accept={ACCEPTED_FORMATS}
                        maxSize={ICON_SIZE}
                     >
                        {({ getRootProps, getInputProps }) => (
                           <div {...getRootProps()}>
                              <input {...getInputProps()} />

                              <IconButton aria-label="upload-video" className={classes.uploadIconModal}>
                                 {iconStateChange && <CloudUploadIcon style={{ fontSize: 60 }} />}

                                 {confirmationMessage && (
                                    <div>
                                       <img src={uploadChange} alt="" />
                                    </div>
                                 )}
                                 {iconConfirm && (
                                    <div>
                                       <img src={uploadSave} alt="" />
                                    </div>
                                 )}
                              </IconButton>
                           </div>
                        )}
                     </Dropzone>
                     {confirmationMessage ? <ConfirmationMessage /> : <UploadVideoMessage />}
                  </div>
               </Paper>
            </div>
         </Modal>
      )
   }

   const IconImage = ({ error }) => {
      let nameShow = ''

      if (typeof formData.file === 'string') {
         const urlString = formData.file
         const newurlString = urlString.split('').reverse().join('')
         const field = newurlString.split('/')
         const nameField = field[0]
         nameShow = nameField.split('').reverse().join('')
      } else {
         nameShow = ''
      }

      return (
         <>
            <div
               className={error == true ? classes.uploadImage2 : classes.uploadImage}
               onClick={() => setOpenModal(true)}
               name="file"
            >
               {formBehavior == 'EDIT' ? (
                  <Typography className={error == true ? classes.imageText2 : classes.imageText}>
                     {formData.file.path ? `${formData.file.path}` : `${nameShow}`}
                  </Typography>
               ) : (
                  <Typography className={error == true ? classes.imageText2 : classes.imageText}>
                     {' '}
                     {temporalFile ? `${temporalFile[0].name}` : 'Cargar ícono Mundo Mutual*'}{' '}
                  </Typography>
               )}
               <CloudUploadIcon className={classes.iconImage} />
            </div>
            {error && <p className={classes.errorImg}>El icono mundo mutual es obligatorio</p>}
         </>
      )
   }

   return (
      <div className={classes.formContainer}>
         <AddVideoModal />
         <Typography className={classes.titleOne}>
            <b> Completa los campos </b>{' '}
         </Typography>
         <form className={classes.form} encType="multipart/form-data">
            <FormControl variant="outlined" size="small" className={classes.formControl} error={invalid.name}>
               <InputLabel htmlFor="outlined-adornment-amount"> Nombre de la aplicación *</InputLabel>
               <OutlinedInput
                  label="Nombre de la aplicación"
                  value={formData.name}
                  onChange={addValuesToMemory}
                  name="name"
                  size="small"
                  endAdornment={invalid.name && <TooltipInputError title={'Ingrese un nombre de aplicación válido'} />}
               />
               <FormHelperText className={classes.helperText}>
                  {invalid.name && 'Ingrese un nombre de aplicación válido'}
               </FormHelperText>
            </FormControl>
            <FormControl variant="outlined" className={classes.formControl} margin="dense" error={invalid.type}>
               <InputLabel htmlFor="outlined-type-aplication"> Tipo de aplicación * </InputLabel>
               <Select
                  value={formData?.type}
                  onChange={addValuesToMemory}
                  size="small"
                  name="type"
                  label="Tipo de Aplicacion"
                  inputProps={{
                     name: 'type',
                     id: 'outlined-type-aplication'
                  }}
               >
                  <MenuItem aria-label="None" value={''} />
                  {VALUES.APPLICATION_TYPE_OPTIONS.map(option => (
                     <MenuItem key={option.value} value={option.value}>
                        {option.label}
                     </MenuItem>
                  ))}
               </Select>
               <FormHelperText className={classes.helperText}>
                  {invalid.type && 'El campo Tipo de Aplicación es obligatorio'}
               </FormHelperText>
            </FormControl>
            {!isSearch && (
               <>
                  <FormControl variant="outlined" margin="dense" className={classes.formControl} error={invalid.link}>
                     <InputLabel htmlFor="outlined-adornment-link-amount">Enlace de la aplicación</InputLabel>
                     <OutlinedInput
                        error={invalid.link}
                        value={formData.link}
                        onChange={addValuesToMemory}
                        label="Enlace de la aplicación"
                        name="link"
                        size="small"
                        disabled
                        endAdornment={invalid.link && <TooltipInputError title={'Ingrese un link válido'} />}
                     />
                     <FormHelperText className={classes.helperText}>
                        {invalid.link && 'El campo Enlace de la aplicación es obligatorio'}
                     </FormHelperText>
                  </FormControl>
                  <FormControl
                     variant="outlined"
                     margin="dense"
                     className={classes.formControl}
                     error={invalid.resource}
                  >
                     <InputLabel htmlFor="outlined-adornment-link-amount">Url de los recursos *</InputLabel>
                     <OutlinedInput
                        error={invalid.resource}
                        value={formData.resource}
                        onChange={addValuesToMemory}
                        label="Url de los recursos"
                        name="resource"
                        size="small"
                        endAdornment={invalid.resource && <TooltipInputError title={'Ingrese una url válida'} />}
                     />
                     <FormHelperText className={classes.helperText}>
                        {invalid.resource && 'El campo Enlace de la aplicación es obligatorio'}
                     </FormHelperText>
                  </FormControl>
                  <FormControl className={classes.containerIconImage}>
                     <IconImage error={invalid.file} value={formData.file}></IconImage>
                  </FormControl>
               </>
            )}
            <FormControl variant="outlined" className={classes.formControl} margin="dense" error={invalid.subdomainId}>
               <Autocomplete
                  value={subdomainObject}
                  options={subdomainsGrouped.sort((a, b) => -b.firstLetter.localeCompare(a.firstLetter))}
                  getOptionSelected={(option, value) => option.id === value.id}
                  getOptionLabel={option => (option.name ? utils.capitalizeFirstLetter(option.name) : option?.name)}
                  groupBy={option => option.firstLetter}
                  onChange={handleSubdomainName}
                  size="small"
                  name="subdomainId"
                  renderInput={params => (
                     <TextField
                        {...params}
                        getOptionSelected={(option, value) => option.id === value.id}
                        label={isSearch ? 'Tipo de subdominio *' : 'Nombre del subdominio *'}
                        variant="outlined"
                        error={invalid.subdomainId}
                     />
                  )}
               />
            </FormControl>
            {formBehavior !== VALUES.FORM_BEHAVIOR.REGISTER && (
               <>
                  <FormControl variant="outlined" className={classes.formControl} size="small" error={invalid.status}>
                     <InputLabel htmlFor="outlined-type-native-simple">Estado de la Aplicación</InputLabel>
                     <Select
                        value={formData.status}
                        onChange={addValuesToMemory}
                        label="Estado de la Aplicación"
                        size="small"
                        name="status"
                        inputProps={{
                           name: 'status',
                           id: 'outlined-type-native-simple'
                        }}
                     >
                        <MenuItem aria-label="None" value={''} />
                        {VALUES.STATUS_OPTIONS.map(option => (
                           <MenuItem key={option.value} value={option.value}>
                              {option.label}
                           </MenuItem>
                        ))}
                     </Select>
                     <FormHelperText className={classes.helperText}>
                        {invalid.status && 'El campo Estado de la Aplicación es obligatorio'}
                     </FormHelperText>
                  </FormControl>
               </>
            )}
            <Button
               type="submit"
               fullWidth
               variant="contained"
               color="primary"
               classes={{
                  disabled: classes.disabledButton,
                  root: classes.button
               }}
               onClick={actionSubmitEvent}
               disabled={isSearch ? !CONSULTAR_APLICACION : !REGISTRAR_APLICACION}
            >
               {formBehavior === VALUES.FORM_BEHAVIOR.EDIT
                  ? TRANSLATE.BUTTONS.EDIT
                  : isSearch
                  ? TRANSLATE.BUTTONS.SEARCH
                  : TRANSLATE.BUTTONS.SAVE}
            </Button>
            <Button
               classes={{
                  root: classes.formCleanButton
               }}
               variant="outlined"
               onClick={cleanForm}
            >
               {TRANSLATE.BUTTONS.CLEAN}
            </Button>
         </form>
      </div>
   )
}

export default ApplicationForm
